module.exports = __webpack_public_path__ + "assets/467734b3c7285aff7b99ee4e991f37f7.mp4";